import { Star } from "components/Icon/Star"
import { StarRegular } from "components/Icon/StarRegular"

export function Rating(props) {
  const { value } = props
  let array = []
  for (let i = 0; i < 4; i++) {
    const StarVersion = value > i ? Star : StarRegular
    array.push(<StarVersion className="w-4 h-4 text-secondary-default" />)
  }
  return <div className="flex flex-row space-x-2">{array}</div>
}
